import { createReducer } from 'Utils';

const UPDATE_PROP = 'pages/UPDATE_PROP';

const initialState = {
  totalPages: null,
  currentPage: 1,
};

const updateProp = (prop, value) => ({
  type: UPDATE_PROP,
  payload: {
    prop,
    value,
  },
});

export const setCurrentPage = value => updateProp('currentPage', value);
export const setTotalPages = value => updateProp('totalPages', value);

export const getCurrentPage = state => state.pagination.currentPage;
export const getTotalPages = state => state.pagination.totalPages;

export default createReducer(initialState, {
  [UPDATE_PROP]: (state, { prop, value }) => ({
    ...state,
    [prop]: value,
  }),
});
